export default {
      id: "oc-organization-usage",
      viewBox: "0 0 1157 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-organization",
      toString: function () {
        return this.url;
      }
    }